export default __webpack_public_path__ + "static/media/imageFive.7751c35f.png";